import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgxEchartsModule } from 'ngx-echarts';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MenuModule } from 'primeng/menu';
import { InputSwitchModule } from 'primeng/inputswitch';

import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';

import { LmsTableComponent } from './lms-table/lms-table.component';
import { LmsChartComponent } from './lms-chart/lms-chart.component';
import { LmsBreadcrumbComponent } from './lms-breadcrumb/lms-breadcrumb.component';
import { LmsFooterComponent } from './lms-footer/lms-footer.component';
import { LmsHeaderComponent } from './lms-header/lms-header.component';
import { ButtonModule } from 'primeng/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastModule } from 'primeng/toast';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { LmsMultiSelectComponent } from './lms-multi-select/lms-multi-select.component';
import { LmsCalenderComponent } from './lms-calendar/lms-calendar.component';
import { LmsNavBarComponent } from './lms-nav-bar/lms-nav-bar.component';
import { ToastMessageComponent } from './lms-toast-messages/toast-component/toast-message.component';
import { MessageService } from 'primeng/api';
import { MatDividerModule } from '@angular/material/divider';
import { LogoutConfirmComponent } from './lms-header/logout-confirm/logout-confirm.component';
import { LogoutConfirmService } from './lms-header/logout-confirm/logout-confirm.service';
import { HeaderModule } from '../../header/header.module';

@NgModule({
  declarations: [
    LmsTableComponent,
    LmsChartComponent,
    LmsBreadcrumbComponent,
    LmsFooterComponent,
    LmsHeaderComponent,
    LmsMultiSelectComponent,
    LmsCalenderComponent,
    LmsNavBarComponent,
    ToastMessageComponent,
    LogoutConfirmComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    DynamicDialogModule,
    OverlayPanelModule,
    MatToolbarModule,
    ButtonModule,
    MatMenuModule,
    MatCheckboxModule,
    MatIconModule,
    TooltipModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
    BreadcrumbModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    DropdownModule,
    ToastModule,
    MultiSelectModule,
    NgxDaterangepickerMd.forRoot(),
    MenuModule,
    InputSwitchModule,
    MatDividerModule,
    HeaderModule,
  ],
  providers: [DialogService, MessageService, LogoutConfirmService],
  exports: [
    LmsTableComponent,
    CommonModule,
    FormsModule,
    LmsChartComponent,
    LmsNavBarComponent,
    LmsHeaderComponent,
    LmsBreadcrumbComponent,
    LmsFooterComponent,
    ToastMessageComponent,
    LmsMultiSelectComponent,
    LmsCalenderComponent,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    ToastModule,
    DropdownModule,
    MultiSelectModule,
    MenuModule,
    LogoutConfirmComponent
  ],
})
export class CommonComponentModule {}
